import React, { FunctionComponent } from 'react';
import { IEmployeeBoxProps } from '../employee-box/employee-box';
import styles from './article-author-small-box.module.scss';

export interface IArticleAuthorSmallBoxProps {
  author: IEmployeeBoxProps;
  displayPosition?: boolean;
  theme?: string;
}

export const ArticleAuthorSmallBox: FunctionComponent<IArticleAuthorSmallBoxProps> = ({
  author,
  displayPosition,
  theme
}) => (
  <div className={`${styles.author} ${theme === 'dark' && styles.dark}`}>
    {author.photoUrl ? (
      <img src={author.photoUrl} alt="Author" className={styles.authorPhoto} />
    ) : null}
    <div className={styles.authorInfo}>
      <div className={displayPosition ? styles.bold : ''}>
        {author.firstName} {author.lastName}
      </div>
      {author.position && displayPosition && <div>{author.position}</div>}
    </div>
  </div>
);
